import estateCuredService from '../../api/estatecuredbrokerfile'

const state = {
    files: [],
    paginationInfo: { totalPages: 0, size: 0, number: 0 },
    records: [],
    pendingRecords: [],
    numberOfLinks: 0,
    numberOfItemsPerPage: 7,
    currentPage: 0,
    loading: false

}

const mutations = {
    setFiles (state, files) {
        state.files = files
    },
    setFilesWithPagination (state, response) {
        state.paginationInfo = response.data.page

        state.files = response.data.content
    },

    setRecords (state, records) {
        state.records = records
    },
    setPendingRecords (state, records) {
        state.pendingRecords = records
    },

    setLoading (state, payload) {
        state.loading = payload
    }

}

const actions = {
    getFiles ({ commit }) {
        estateCuredService.getFiles().then(response => {
            commit('setFiles', response.data)
        }).catch(error => {
            console.log(error)
        })
    },
    getFilesWithPagination ({ commit }, payload) {
        commit('setLoading', true)
        estateCuredService.getFilesWithPagination(payload).then(response => {
            commit('setFilesWithPagination', response)
            commit('setLoading', false)
        }).catch(error => {
            commit('setLoading', false)
            console.log(error)
        })
    },
    uploadFile ({ commit }, formData) {
        return new Promise((resolve, reject) => {
            estateCuredService.uploadFile(formData).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    approveFile ({ commit }, file) {
        return new Promise((resolve, reject) => {
            estateCuredService.approveFile(file).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    rejectFile ({ commit }, file) {
        return new Promise((resolve, reject) => {
            estateCuredService.rejectFile(file).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    viewFile ({ commit }, fileId) {
        commit('setLoading', true) // Set loading state to true

        estateCuredService.viewFile(fileId).then(response => {

            commit('setRecords', response.data)
            commit('setLoading', false)
        }).catch(error => {
            console.log(error)
            commit('setLoading', false)
        })
    },
    viewPendingCollection ({ commit }) {
        commit('setLoading', true) // Set loading state to true

        estateCuredService.viewPendingCollection().then(response => {
            console.log("Loaded grn Records",response)
            commit('setRecords', response.data)
            commit('setLoading', false)
        }).catch(error => {
            console.log(error)
            commit('setLoading', false)
        })
    },


    resetestatecuredbrokerfiles ({ commit }) {
        // console.log("Loaded grn Records",response)
        commit('setLoading', true)
        commit('setRecords', [])
    },
    viewDeletedFile ({ commit }, fileId) {
        estateCuredService.viewDeletedFile(fileId).then(response => {
            commit('setRecords', response.data)
            // console.log('Grn>>>', response.data)
        }).catch(error => {
            console.log(error)
        })
    },
    download ({ commit }, fileId) {
        return new Promise((resolve, reject) => {
            estateCuredService.download(fileId).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    warehouseApproveRecords ({ commit }, records) {
        return new Promise((resolve, reject) => {
            estateCuredService.warehouseApproveRecords(records).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    warehouseApproveRecords2 ({ commit }, records) {
        return new Promise((resolve, reject) => {
            estateCuredService.brokerApproveRecords(records).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    sweepingsApproveRecords ({ commit }, records) {
        console.log('hello===')
        return new Promise((resolve, reject) => {
            estateCuredService.sweepingsApproveRecords(records).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    millerApproveRecord ({ commit }, record) {
        return new Promise((resolve, reject) => {
            estateCuredService.millerApproveRecord(record).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    editRecord ({ commit }, record) {
        return new Promise((resolve, reject) => {
            estateCuredService.editRecord(record).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getRecordsPendingApproval ({ commit }) {
        estateCuredService.getRecordsPendingApproval().then(response => {
            commit('setPendingRecords', response.data)
        }).catch(error => {
            console.log(error)
        })
    }
}

const getters = {
    isLoading (state) {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
